import { useState } from "react";
import logo from "../../../../assets/images/discover-logo.png";
import master from "../../../../assets/images/master.png";
import visa from "../../../../assets/images/visa.png";
import { Input, Button, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { scrollToTopSmooth, validateEmail } from "../../../../util";
import Grid from "@material-ui/core/Grid";
import axios from "axios";

function Arrow() {
  return (
    <svg
      className="right-arrow"
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
    >
      <path
        d="M4.16663 1.66665L7.49996 4.99998L4.16663 8.33331"
        stroke="currentColor"
        strokeWidth="2"
        stroklinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const SocialMediaIcons = [];

export default function Info() {
  const menuData = [
    {
      name: "Destinations",
      link: "/view-all-destination",
    },  
    {
      name: "About Us",
      link: "/aboutus",
    },

    {
      name: "Contact",
      link: "/contactus",
    },
  ];

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: "", message: "" });

  const onSubscribe = async (e) => {
    e.preventDefault();
    setFeedback({ type: "", message: "" });

    if (!firstName.trim()) {
      setFeedback({ type: "error", message: "Please enter your first name." });
      return;
    }
    if (!lastName.trim()) {
      setFeedback({ type: "error", message: "Please enter your last name." });
      return;
    }
    if (!email.trim()) {
      setFeedback({ type: "error", message: "Please enter your email address." });
      return;
    }
    if (!validateEmail(email)) {
      setFeedback({ type: "error", message: "Please enter a valid email address." });
      return;
    }

    setIsLoading(true);
    try {
      await axios.post(
        "https://connect.mailerlite.com/api/subscribers",
        {
          email: email.trim(),
          fields: {
            name: firstName.trim(),
            last_name: lastName.trim(),
          },
          groups: [process.env.REACT_APP_MAILERLITE_GROUP_ID],
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_MAILERLITE_API_KEY}`,
          },
        }
      );
      setFeedback({
        type: "success",
        message: "Thank you! You are now subscribed to Discover Shurooq updates.",
      });
      setFirstName("");
      setLastName("");
      setEmail("");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        "Something went wrong. Please try again later.";
      setFeedback({ type: "error", message: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="info">
      <Grid container spacing={3}>
        <Grid item xs={12} lg={3}>
          <div className="sub-content">
            <img src={logo} className="logo" alt="logo" />
          </div>
        </Grid>
        <Grid item xs={12} lg={5}>
            <div className="subsctibe">
              <h6 className="subscribe-heading">Subscribe To Our Newsletters</h6>
              <p className="subscribe-subtext">Sign up to stay abreast of our news and developments.</p>
              <form onSubmit={onSubscribe}>
                <div className="subscribe-name-row">
                  <Input
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    disabled={isLoading}
                  />
                  <Input
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    disabled={isLoading}
                  />
                </div>
                <div className="subscribe-email-row">
                  <div className="flex-grow-1">
                    <Input
                      type="email"
                      placeholder="Enter your email id"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isLoading}
                    />
                  </div>
                </div>
                <Button type="submit" color="primary" disabled={isLoading} className="subscribe-btn">
                  {isLoading ? <Spinner size="sm" /> : "Subscribe"}
                </Button>
                {feedback.message && (
                  <p className={`subscribe-feedback subscribe-feedback--${feedback.type}`}>
                    {feedback.message}
                  </p>
                )}
                <p className="subscribe-consent">
                  I consent to receive exclusive marketing communications from Discover Shurooq. Further details on how we process your personal data
                  can be found in our{" "}
                  <Link to="/privacy" onClick={scrollToTopSmooth}>
                    Privacy policy
                  </Link>
                  . You can withdraw your consent at any time by following the
                  unsubscribe instructions in any marketing communications received.
                </p>
              </form>
            </div>
        </Grid>
        <Grid item xs={12} lg={4}>
          <div className="f-menus">
            {/* <h3>Menu</h3> */}
            <div className="menu-items">
              {menuData.map(({ name, link }, index) => (
                <div key={index} className="menu-item">
                  <Link to={link} onClick={scrollToTopSmooth}>
                    {name}
                    <Arrow />
                  </Link>
                </div>
              ))}
            </div>
            <div>
              <div className="b-links">
                <Link to="/terms" onClick={scrollToTopSmooth}>
                  Terms
                </Link>
                <Link to="/privacy" onClick={scrollToTopSmooth}>
                  Privacy
                </Link>
              </div>
              <div
                className="f-icons"
                style={{ fontSize: "130%", cursor: "pointer" }}
              >
                {/* <i className="fab fa-youtube fa-lg you"></i>
                <i className="fab fa-facebook fa-lg face"></i> */}
                <a
                  href="https://www.instagram.com/discovershurooq/"
                  target="_blank"
                >
                  <i className="fab fa-instagram fa-lg insta"></i>
                  
                </a>
              </div>
              <p className="copy-text">
                Sharjah Investment and Development Authority (Shurooq) ©2021
                <br />
                All rights reserved. Government of Sharjah
              </p>
              <img src={master} className="master" alt="master" style={{width:"64px"}} />
            <img src={visa} className="visa" alt="visa" style={{width:"64px"}} />

            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
